<template>
  <div class="company-wrap" v-animate-on-scroll="'animate__fadeInUp'">
    <img src="@/assets/images/icon-1.png" alt="" class="icon-image" />
    <div class="company-row">
      <div class="company-lt">
        <div class="lt-title">
          <div class="title-tip">
            通文服务
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="9"
              viewBox="0 0 20 9"
              fill="none"
              class="title-icon"
            >
              <path
                d="M10.669 8.39793C10.2887 8.74021 9.71134 8.74021 9.33103 8.39793L0 0L20 0L10.669 8.39793Z"
                fill="#1B56A9"
              />
            </svg>
          </div>
          <div class="title-hr"></div>
        </div>
        <div class="lt-item" v-html="companyDesc.articleContent"></div>
        <div class="more-btn" @click="handleCompany()">了解更多>></div>
      </div>
      <div class="company-rt">
        <Banner compact></Banner>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticleById } from '@/api/home/home.js'
import Banner from './Banner.vue'
export default {
  components: { Banner },
  data() {
    return {
      companyDesc: {} // 公司信息
    }
  },
  created() {
    this.getArticleData(317582750246152)
  },
  methods: {
    // 公司信息
    getArticleData(id) {
      getArticleById(id).then((res) => {
        if (!res.data) return
        this.companyDesc = res.data
      })
    },
    //跳转更多
    handleCompany() {
      let url =
        '/article?categoryId=108&linkType=1&tabcode=102&seccode=108&id=317582750246152'
      this.$router.push(url)
    }
  }
}
</script>

<style scoped lang="scss">
.company-wrap {
  display: flex;
  flex-direction: column;
  width: 1340px;
  margin: 64px auto 120px;
  .company-row {
    display: flex;
    flex-direction: row;
    .company-rt {
      width: 724px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
    .company-lt {
      flex: 1;
      margin-right: 34px;
      display: flex;
      flex-direction: column;
      .more-btn {
        margin-top: 64px;
        background: #1b56a9;
        width: 176px;
        height: 54px;
        line-height: 54px;
        text-align: center;
        font-size: 24px;
        color: #fff;
        font-weight: 500;
        cursor: pointer;
      }
      .lt-item {
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 8;
        color: #333;
        font-size: 20px;
        line-height: 36px;
      }
      .lt-title {
        display: flex;
        flex-direction: row;
        height: 56px;
        .title-hr {
          background: #e6e6e6;
          height: 1px;
          flex: 1;
          margin-top: auto;
          margin-bottom: 9px;
        }
        .title-tip {
          display: flex;
          flex-direction: column;
          min-width: 127px;
          text-align: center;
          background: #1b56a9;
          height: 47px;
          line-height: 47px;
          font-size: 24px;
          font-weight: 600;
          color: #fff;
          position: relative;
          .title-icon {
            width: 20px;
            height: 9px;
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
            bottom: -9px;
          }
        }
      }
    }
  }
  .icon-image {
    width: 250px;
    height: 64px;
    margin: 0 auto 34px;
  }
}

// 手机端css
.mobile-content {
  .company-wrap {
    width: 345px;
    margin: 24px auto 60px;
    .company-row {
      flex-direction: column;
      .company-rt {
        width: 100%;
        margin-top: 10px;
      }
      .company-lt {
        margin-right: 0;
        .more-btn {
          margin-top: 32px;
          width: 110px;
          height: 35px;
          line-height: 35px;
          font-size: 14px;
          margin: 32px auto 0;
        }
        .lt-item {
          font-size: 14px;
          line-height: 30px;
        }
        .lt-title {
          height: 39px;
          line-height: 39px;
          .title-tip {
            height: 30px;
            line-height: 30px;
            font-size: 16px;
            min-width: 100px;
            .title-icon {
              width: 10px;
              height: 4.5px;
              bottom: -4.5px;
            }
          }
        }
      }
    }
    .icon-image {
      width: 150px;
      height: 38.4px;
    }
  }
}
</style>
